import { useQuery } from '@tanstack/react-query';
import Addon from '../models/Addon';

// The add-ons on the Announcements & Gifts grid.
//
// ⚠️ Filters `onGiftsPage`, which is the DATABASE COLUMN `is_holiday` under a
// name that says what it does. That column decides page membership and nothing
// else: it began as a seasonal range and grew to carry grad announcements,
// audience-priced prints and an 8x10, while 34 other add-ons are package-builder
// sheets that must never reach this grid. It is NOT a season, and NOT a
// shortcut around isSenior/isElementary — ItemAdder still scopes by audience.
//
// The API serves both names for now; the column keeps its old one until no
// cached bundle asks for `is_holiday`. See Api::AddonResource.
export default function useGiftsPageAddons() {
  return useQuery(['addons', 'giftsPage'], () => (
    Addon
      .where({ onGiftsPage: true })
      .all()
      .then((res) => res.data)
  ), { placeholderData: [] });
}
